import { format, formatDistanceToNow } from 'date-fns'

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount)
}

export const formatForeignCurrency = (
  amount: number,
  currency: string,
): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
  }).format(amount)
}

export const formatDate = (dateString: string | Date): string => {
  return format(new Date(dateString), 'MMM dd, yyyy')
}

export const formatDateTime = (dateString: string | Date): string => {
  return format(new Date(dateString), 'MMM dd, yyyy HH:mm')
}

export const formatRelativeTime = (dateString: string | Date): string => {
  return formatDistanceToNow(new Date(dateString), { addSuffix: true })
}

export const generateReference = (prefix: string = 'REF'): string => {
  const timestamp = Date.now().toString().slice(-6)
  const random = Math.floor(Math.random() * 10000)
    .toString()
    .padStart(4, '0')
  return `${prefix}-${timestamp}-${random}`
}
